import React from 'react';

/** Header strip + optional subtitle for match widgets. */
export default function MatchWidgetShell({
  competitionLabel = '',
  title = '',
  subtitle = '',
  badge = null,
  showCompetition = true,
  children,
  className = '',
}) {
  const headerText = title || competitionLabel;
  const showHeader =
    (showCompetition && competitionLabel) ||
    (headerText && headerText !== competitionLabel) ||
    badge;

  return (
    <div className={`sw-match-widget overflow-hidden ${className}`} style={{ background: 'var(--sw-bg)', color: 'var(--sw-text)' }}>
      {showHeader && (
        <div
          className="sw-match-header px-4 py-2.5 flex items-center justify-between gap-2 border-b"
          style={{ borderColor: 'var(--sw-border)' }}
        >
          <div className="min-w-0">
            {showCompetition && competitionLabel && (
              <p className="text-[10px] font-bold uppercase tracking-widest truncate" style={{ color: 'var(--sw-accent)' }}>
                {competitionLabel}
              </p>
            )}
            {headerText && headerText !== competitionLabel && (
              <p className="text-xs font-semibold truncate mt-0.5">{headerText}</p>
            )}
          </div>
          {badge}
        </div>
      )}
      {subtitle && (
        <p className="px-4 py-1 text-[10px] border-b" style={{ borderColor: 'var(--sw-border)', color: 'var(--sw-muted)' }}>
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
}
